import { FinanceLabField, getFinanceLabMetrics } from "@/entities/FinanceLab";
import { useApiQuery } from "@/api";
import clsx from "clsx";
import { useColorizedValue, DataSource } from "../hooks/useColorizedValue";
import { useFlags } from "@/utils/flagsmith/useFlags";
import { getLastValue } from "@/utils/metrics/metricsUtils";
import { SparklesIcon } from "@heroicons/react/24/solid";
import { ExpandableMarkdown } from "./ExpandableMarkdown";

export function TransactionSummary() {
    const { data: summary } = useApiQuery(getFinanceLabMetrics, {
        params: {
            labels: [FinanceLabField.DEAL_TRANSACTION_SUMMARY],
        },
    });
    const flags = useFlags();
    const showDataSources = flags.enabled("show-data-sources");

    const summaryColorized = useColorizedValue(
        getLastValue(summary?.[0]?.values)?.formattedValue || "-",
        DataSource.FINANCE_LAB,
        FinanceLabField.DEAL_TRANSACTION_SUMMARY,
    );

    return (
        <div>
            <div
                className={clsx("body-s", "text-slate-600 dark:text-slate-300")}
            >
                <ExpandableMarkdown
                    text={summaryColorized.value}
                    maxLength={1800}
                />
            </div>
            {showDataSources && summaryColorized.source && (
                <span
                    className={clsx(
                        "mt-1 text-[9px] tracking-wide",
                        summaryColorized.sourceClassName,
                    )}
                >
                    {summaryColorized.source}
                </span>
            )}

            <div
                className={clsx(
                    "mt-2 w-fit bg-slate-700 px-2 py-1",
                    "flex items-center gap-2 rounded-full",
                )}
            >
                <span className="ui-label text-white">AI-Generated</span>
                <SparklesIcon className="size-4" />
            </div>
        </div>
    );
}
